import React, { useState, useRef, useEffect } from "react";
import EditableSvg from "./EditableSvg";
import EditableText from "./EditableText";
import EventsMap from "./EventsMap.jsx";
import EditableLocation from "./EditableLocation.jsx";
import { ColorPalleteSVG, FontMinusSVG, FontPlusSVG, MenuSVG } from "./SVG.jsx";
const Timeline = ({ rsvp, isEditable = false, onUpdate }) => {
  return (
    <section className="font-display">
      <div className="text-gray-800 py-8 mx-0 sm:mx-6">
        <div className={`container mx-auto flex flex-col items-center my-12 `}>
          {rsvp.quote && (
            <div className="flex flex-col mt-2 px-8 text-center">
              <EditableText
                text={rsvp.quoteText}
                onTextChange={(text) => onUpdate?.({ quoteText: text })}
                className={`text-xl leading-normal mb-2 font-${rsvp.quoteFont}`}
                style={{ color: rsvp.quoteColor }}
                font={rsvp.quoteFont}
                fontSize={rsvp.quoteFontSize}
                color={rsvp.quoteColor}
                onStyleChange={(style) => {
                  if (style.font) onUpdate({ quoteFont: style.font });
                  if (style.color) onUpdate({ quoteColor: style.color });
                  if (style.fontSize)
                    onUpdate({ quoteFontSize: style.fontSize });
                  if (style.isBold !== undefined)
                    onUpdate({ quoteIsBold: style.isBold });
                  if (style.isItalic !== undefined)
                    onUpdate({ quoteIsItalic: style.isItalic });
                }}
                isEditable={isEditable}
                isBold={rsvp.quoteIsBold}
                isItalic={rsvp.quoteIsItalic}
              />
              {/* {rsvp.quoteAuthor && ( */}
              {/*   <EditableText */}
              {/*     text={`- ${rsvp.quoteAuthor}`} */}
              {/*     onTextChange={(text) => */}
              {/*       onUpdate?.({ quoteAuthor: text.replace("- ", "") }) */}
              {/*     } */}
              {/*     className={`text-xl leading-normal mb-2 font-${rsvp.quoteFont}`} */}
              {/*     style={{ color: rsvp.quoteColor }} */}
              {/*     font={rsvp.quoteFont} */}
              {/*     fontSize={rsvp.quoteFontSize} */}
              {/*     color={rsvp.quoteColor} */}
              {/*     onStyleChange={(style) => { */}
              {/*       if (style.font) onUpdate({ quoteFont: style.font }); */}
              {/*       if (style.color) onUpdate({ quoteColor: style.color }); */}
              {/*       if (style.fontSize) */}
              {/*         onUpdate({ quoteFontSize: style.fontSize }); */}
              {/*     }} */}
              {/*     isEditable={isEditable} */}
              {/*   /> */}
              {/* )} */}
            </div>
          )}
          <div className={`ml-0`}>
            <div className="container mx-auto w-full h-full">
              <div className="relative wrap overflow-hidden p-10 h-full">
                <EditableBorder
                  color={rsvp.borderColor}
                  width={rsvp.borderWidth}
                  isEditable={isEditable}
                  onUpdate={onUpdate}
                />
                {rsvp.events
                  .sort((a, b) => {
                    const [aH, aM] = a.time.split(":").map(Number);
                    const [bH, bM] = b.time.split(":").map(Number);
                    return aH * 60 + aM - (bH * 60 + bM);
                  })
                  .map((ev, idx) => (
                    <React.Fragment key={idx}>
                      <TimelineEvent
                        ev={ev}
                        idx={idx}
                        highlightColor={rsvp.highlightColor}
                        textColor={rsvp.textColor}
                        highlightFont={rsvp.highlightFont}
                        eventTimeFont={rsvp.eventTimeFont}
                        eventTimeFontSize={rsvp.eventTimeFontSize}
                        eventTimeColor={rsvp.eventTimeColor}
                        eventTitleFont={rsvp.eventTitleFont}
                        eventTitleFontSize={rsvp.eventTitleFontSize}
                        eventTitleColor={rsvp.eventTitleColor}
                        eventLocationColor={rsvp.eventLocationColor}
                        eventLocationFont={rsvp.eventLocationFont}
                        eventLocationFontSize={rsvp.eventLocationFontSize}
                        eventLocationIsBold={rsvp.eventLocationIsBold}
                        eventLocationIsItalic={rsvp.eventLocationIsItalic}
                        eventTitleIsBold={rsvp.eventTitleIsBold}
                        eventTitleIsItalic={rsvp.eventTitleIsItalic}
                        eventTimeIsBold={rsvp.eventTimeIsBold}
                        eventTimeIsItalic={rsvp.eventTimeIsItalic}
                        isEditable={isEditable}
                        onUpdate={onUpdate}
                        rsvp={rsvp}
                        onRemove={() => {
                          const updatedEvents = rsvp.events.filter(
                            (_, i) => i !== idx,
                          );
                          onUpdate?.({ events: updatedEvents });
                        }}
                      />
                    </React.Fragment>
                  ))}
                {isEditable && (
                  <div className="flex mb-4 z-[99]">
                    <button
                      onClick={() => {
                        const newEvent = {
                          time: "00:00",
                          eventName: "Novi događaj",
                          location: "Lokacija",
                          icon: "001",
                        };
                        onUpdate?.({ events: [...rsvp.events, newEvent] });
                      }}
                      className="py-2 px-4 inline-flex font-sans items-center gap-x-2 text-sm rounded-lg border border-transparent bg-teal-600 text-white hover:bg-teal-600 disabled:opacity-50 disabled:pointer-events-none  :outline-none  :ring-1  :ring-gray-600"
                    >
                      Dodaj događaj
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const TimelineEvent = ({
  ev,
  idx,
  highlightColor,
  textColor,
  eventTimeFont,
  eventTimeFontSize,
  eventTimeColor,
  eventTitleFont,
  eventTitleFontSize,
  eventTitleColor,
  eventLocationFont,
  eventLocationFontSize,
  eventLocationColor,
  isEditable = false,
  onUpdate,
  rsvp,
  onRemove,
  eventLocationIsBold,
  eventLocationIsItalic,
  eventTitleIsBold,
  eventTitleIsItalic,
  eventTimeIsBold,
  eventTimeIsItalic,
}) => {
  return (
    <div
      className={`mb-8 flex justify-between items-center w-full ${
        idx % 2 === 0 ? "left-timeline" : "right-timeline flex-row-reverse"
      }`}
    >
      <div
        className={`order-1 w-5/12 ${
          idx % 2 === 0 ? "text-right" : "text-left"
        }`}
      >
        {ev.icon && (
          <div
            className={`flex ${
              idx % 2 === 0 ? "justify-end" : "justify-start"
            }`}
          >
            <EditableSvg
              icon={ev.icon}
              highlightColor={highlightColor}
              textColor={textColor}
              scale={false}
              className="w-1/3"
              isEditable={isEditable}
              onStyleChange={(style) => {
                const updatedEvents = [...rsvp.events];
                if (style.icon) {
                  updatedEvents[idx] = { ...ev, icon: style.icon };
                  onUpdate?.({ events: updatedEvents });
                }
                if (style.highlightColor) {
                  onUpdate?.({ highlightColor: style.highlightColor });
                }
                if (style.textColor) {
                  onUpdate?.({ textColor: style.textColor });
                }
              }}
            />
          </div>
        )}
      </div>

      <div
        className={`order-1 w-5/12 px-1 py-4 ${
          idx % 2 === 0 ? "text-left" : "text-right"
        } relative`}
      >
        {isEditable && (
          <button
            onClick={onRemove}
            className="absolute top-0 right-0 transform translate-x-5 -translate-y-5 p-1 text-red-500 hover:text-red-700"
            title="Ukloni događaj"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        )}
        <EditableText
          text={ev.time}
          onTextChange={(text) => {
            const updatedEvents = [...rsvp.events];
            updatedEvents[idx] = { ...ev, time: text };
            onUpdate?.({ events: updatedEvents });
          }}
          className={`mb-3 text-base font-${eventTimeFont}`}
          style={{ color: eventTimeColor }}
          font={eventTimeFont}
          color={eventTimeColor}
          fontSize={eventTimeFontSize}
          isBold={eventTimeIsBold}
          isItalic={eventTimeIsItalic}
          onStyleChange={(style) => {
            if (style.font) onUpdate({ eventTimeFont: style.font });
            if (style.color) onUpdate({ eventTimeColor: style.color });
            if (style.fontSize) onUpdate({ eventTimeFontSize: style.fontSize });
            if (style.isBold !== undefined)
              onUpdate({ eventTimeIsBold: style.isBold });
            if (style.isItalic !== undefined)
              onUpdate({ eventTimeIsItalic: style.isItalic });
          }}
          isEditable={isEditable}
        />
        <EditableText
          text={ev.eventName}
          onTextChange={(text) => {
            const updatedEvents = [...rsvp.events];
            updatedEvents[idx] = { ...ev, eventName: text };
            onUpdate?.({ events: updatedEvents });
          }}
          className={`mb-3 font-bold text-lg font-${eventTitleFont}`}
          style={{ color: eventTitleColor }}
          font={eventTitleFont}
          color={eventTitleColor}
          fontSize={eventTitleFontSize}
          onStyleChange={(style) => {
            if (style.font) onUpdate({ eventTitleFont: style.font });
            if (style.color) onUpdate({ eventTitleColor: style.color });
            if (style.fontSize)
              onUpdate({ eventTitleFontSize: style.fontSize });
            if (style.isBold !== undefined)
              onUpdate({ eventTitleIsBold: style.isBold });
            if (style.isItalic !== undefined)
              onUpdate({ eventTitleIsItalic: style.isItalic });
          }}
          isEditable={isEditable}
          isBold={eventTitleIsBold}
          isItalic={eventTitleIsItalic}
          tag="h4"
        />
        <EditableLocation
          text={ev.location}
          location={ev.location}
          coordinates={ev.coordinates}
          onTextChange={(text) => {
            const updatedEvents = [...rsvp.events];
            updatedEvents[idx] = { ...ev, location: text };
            onUpdate?.({ events: updatedEvents });
          }}
          onLocationChange={(text, coordinates) => {
            const updatedEvents = [...rsvp.events];
            updatedEvents[idx] = {
              ...ev,
              location: text,
              coordinates: coordinates,
            };
            onUpdate?.({ events: updatedEvents });
          }}
          className={`text-sm leading-snug text-opacity-100 font-${eventLocationFont}`}
          style={{ color: eventLocationColor }}
          font={eventLocationFont}
          fontSize={eventLocationFontSize}
          color={eventLocationColor}
          onStyleChange={(style) => {
            if (style.font) onUpdate({ eventLocationFont: style.font });
            if (style.color) onUpdate({ eventLocationColor: style.color });
            if (style.fontSize)
              onUpdate({ eventLocationFontSize: style.fontSize });
            if (style.isBold !== undefined)
              onUpdate({ eventLocationIsBold: style.isBold });
            if (style.isItalic !== undefined)
              onUpdate({ eventLocationIsItalic: style.isItalic });
          }}
          isEditable={isEditable}
          isBold={eventLocationIsBold}
          isItalic={eventLocationIsItalic}
        />
      </div>
    </div>
  );
};

export default Timeline;

const EditableBorder = ({ color, width, isEditable, onUpdate }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [optionsPosition, setOptionsPosition] = useState({ left: 0, top: 0 });
  const buttonRef = useRef(null);
  const optionsRef = useRef(null);

  const handleButtonClick = () => {
    if (!buttonRef.current) return;

    const rect = buttonRef.current.getBoundingClientRect();
    setOptionsPosition({
      top: rect.bottom + 25,
      left: window.innerWidth / 2,
    });

    setShowOptions((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOptions &&
        optionsRef.current &&
        !optionsRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showOptions]);

  console.log(width);
  return (
    <div className="group">
      {isEditable && (
        <button
          type="button"
          ref={buttonRef}
          onClick={handleButtonClick}
          className="absolute top-3 left-[47%] opacity-0 group-hover:opacity-100 transition-opacity bg-teal-600 rounded-full"
        >
          <MenuSVG />
        </button>
      )}

      {showOptions && (
        <div
          ref={optionsRef}
          className="fixed bg-white rounded-xl shadow-lg ring-1 ring-black ring-opacity-5 z-50 transform -translate-x-1/2"
          style={{
            left: `${optionsPosition.left}px`,
            top: `${optionsPosition.top}px`,
          }}
        >
          <BorderMenu color={color} width={width} onStyleChange={onUpdate} />
        </div>
      )}
      <div
        className="border-2-2 absolute h-full "
        style={{
          right: "50%",
          border: `${width}px solid #000000`,
          borderRadius: "1%",
          borderColor: color,
        }}
      ></div>
      <div
        className="border-2-2 absolute h-full"
        style={{
          left: "50%",
          border: `${width}px solid #000000`,
          borderRadius: "1%",
          borderColor: color,
        }}
      ></div>
    </div>
  );
};
const BorderMenu = ({ color, onStyleChange, width }) => {
  console.log(width);
  return (
    <div className="p-2 z-50">
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onStyleChange({ borderWidth: width - 0.5 })}
            className="p-1 hover:bg-gray-100 rounded"
            title="Decrease font size"
          >
            <FontMinusSVG className="w-5 h-5" />
          </button>
          <button
            onClick={() => onStyleChange({ borderWidth: width + 0.5 })}
            className="p-1 hover:bg-gray-100 rounded"
            title="Increase font size"
          >
            <FontPlusSVG className="w-5 h-5" />
          </button>
        </div>

        <div className="flex items-center">
          <input
            type="color"
            value={color}
            onChange={(e) => onStyleChange({ borderColor: e.target.value })}
            className="sr-only"
            id="colorPicker"
          />
          <label
            htmlFor="colorPicker"
            className="p-1 cursor-pointer hover:bg-gray-100 rounded"
            title="Change color"
          >
            <ColorPalleteSVG className="w-5 h-5" />
          </label>
        </div>
      </div>
    </div>
  );
};
